import styled from 'styled-components';

export const Wrapper = styled.div`
  display: flex;
  flex-flow: column nowrap;
  min-height: 100vh;
`;

export const Main = styled.main`
  flex-grow: 1;
`;

export const TitlePrice = styled.article`
  color: #505050;
  font-weight: 500;
  font-size: .875rem;
`;

export const ContractSection = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;

  @media screen and (max-width: 960px) {
    margin: auto;
    max-width: 375px;
  }
  @media screen and (min-width: 1024px) {
    width: 576px;
    justify-content: space-evenly;
  }
`;

export const ContractNowText = styled.span`
  color: #121A3D;
  font-size: 2.815rem;
  width: 434px;
`;

export const PriceSection = styled.section`
  color: black;
`;

export const Price = styled.section`
  display: flex;
  position: relative;
  align-items: flex-end;
  height: 3.375rem;
`;

export const Currency = styled.strong`
  font-size: 1.625rem;
  @media screen and (min-width: 1024px) {
    font-size: 1.5625rem;
  }
`;

export const IntValue = styled.strong`
  font-size: 3.125rem;
  height: 3.375rem;
    @media screen and (min-width: 1024px) {
    font-size: 4.9375rem;
  }
`;

export const CentsValue = styled.strong`
  align-self: end;
  font-size: 1.625rem;
  margin-top: 6px;
  @media screen and (min-width: 1024px) {
    font-size: 2.375rem;
  }
`;

export const Period = styled.span`
  font-size: .75rem;
  position: absolute;
  right: -10px;
  @media screen and (min-width: 1024px) {
    font-size: .875rem;
    top: 55px;
    right: -5px;
  }
`;
